// One row of the activity stream (Overview) or the notes list (Notes tab).
import React from 'react';
import { relTime } from '../../../lib/conciergeActivityModel';

export default function ActivityRow({ item, now, wide }) {
  return (
    <div className={`cn-act${wide ? ' cn-act--wide' : ''}${item.tone === 'text-in' ? ' cn-act--in' : ''}`}
         data-testid={`activity-${item.id}`}>
      <div className="cn-act__meta">
        <span className={`cn-kind cn-kind--${item.tone}`}>{item.tag}</span>
        <span className="cn-act__when">{relTime(item.at, now)}</span>
      </div>
      <div className="cn-act__main">
        <div className="cn-act__who">{item.who}</div>
        <div className="cn-act__body">{item.body}</div>
      </div>
    </div>
  );
}
